// StatisticaBFN.jsx
import React, { useState, useEffect } from 'react';
import { getPeriods, getListBfn, getListBfnHistory } from './actions';
import { distr_all, schema, HISTORY } from './constants';
import { getPeriodsHistory, convData, getTotal, Headers, Row, Total } from './helpers';
import BfnFilters from './BfnFilters';
import './StatisticaBFN.css';

const StatisticaBFN = (props) => {
    const { isArchive } = props;
    
    const [info, setInfo] = useState([]);
    const [selYear, setSelYear] = useState('');
    const [years, setYears] = useState([]);
    const [selDist, setSelDist] = useState('');
    const [distr, setDistr] = useState([]);
    const [total, setTotal] = useState({});
    const [periods] = useState(getPeriodsHistory());
    const [selPeriod, setSelPeriod] = useState(0);

    useEffect(() => {
        getPeriodYearsAndDistricts();
    }, [isArchive]);

    const getPeriodYearsAndDistricts = () => {
        getPeriods(isArchive, 
            (cursor) => {
                const sortedCurs = cursor.sort((a, b) => {
                    if(a._id > b._id) return -1;
                    if(a._id < b._id) return 1;
                    return 0;
                });

                const firstYear = sortedCurs[0];
                if (firstYear) {
                    const districts = firstYear.dist || [];
                    setYears(sortedCurs);
                    setDistr(districts);
                    setSelYear(`${firstYear._id}:0`);
                    setSelDist(districts.sort()[0] || '');
                }
            }, 
            (err) => alert(`Помилка при отриманні даних щодо груп ${JSON.stringify(err)}`)
        );
    };

    const handleSetYear = (e) => {
        const value = e.target.value;

        if(value === HISTORY) {
            setDistr(distr_all);
            setSelYear(value);
            setSelDist(distr_all[0]);
            return;
        }

        const info = value.split(':');
        const yearIndex = parseInt(info[1]);
        const yearData = years[yearIndex];

        if (!yearData) return;

        let countSol = 0;
        let districts = [];

        yearData.dist.forEach((item) => {
            if (item.match(/Со/) && countSol === 0) {
                countSol += 1;
                districts.push('Солом\'янський');
            } else {
                districts.push(item);
            }
        });

        if(districts.length > 0) {
            setDistr(districts.sort());
            setSelYear(value);
            setSelDist(districts[0]);
        } else {
            setDistr([]);
            setSelYear(value);
            setSelDist(null);
        }
    };

    const handleSetInfo = (data) => {
        setInfo(convData(data));
        setTotal(getTotal(data, schema));
    };

    const getInfo = () => {
        const errorHandler = (err) => alert(`Помилка при отриманні даних ${err}`);

        if(selYear === HISTORY) {
            getListBfnHistory({ district: selDist, period: periods[selPeriod] }, handleSetInfo, errorHandler);
        } else {
            const periodStartYear = selYear.split(":")[0];
            getListBfn({ district: selDist, periodStartYear }, handleSetInfo, errorHandler);
        }
    };

    const handleSetPeriod = (e) => {
        setSelPeriod(parseInt(e.target.value));
    };

    const handleSetDistrict = (e) => {
        setSelDist(e.target.value);
    };

    return (
        <div className="bfn-container">
            <BfnFilters
                years={years}
                distr={distr}
                selYear={selYear}
                selDist={selDist}
                selPeriod={selPeriod}
                periods={periods}
                onYearChange={handleSetYear}
                onDistrictChange={handleSetDistrict}
                onPeriodChange={handleSetPeriod}
                onShowData={getInfo}
            />
            
            <div className="tableFixHead table-responsive">
                <table className="table table-striped" id='tableMainInfoGroupForCopy'>
                    <thead>
                        <Headers schema={schema} />
                    </thead>
                    <tbody>
                        <Total schema={schema} total={total} />
                        {info.map((el, index) => (
                            <Row key={index} schema={schema} d={el} />
                        ))}
                    </tbody>
                </table>
            </div>           
        </div>
    );
};

export default StatisticaBFN;